import { Check } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/site/Reveal";
import { SERVICE_ICONS } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

export const Services = () => {
    const { t } = useLanguage();

    return (
        <section id="services" className="relative py-24 md:py-32" data-testid="services-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <SectionHeader
                    number={t.services.number}
                    label={t.services.label}
                    title={t.services.title}
                    description={t.services.description}
                />
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {t.services.cards.map((service, i) => {
                        const Icon = SERVICE_ICONS[i];
                        return (
                            <Reveal key={service.title} delay={i * 0.12}>
                                <article
                                    className="group glass-card glass-card-hover rounded-2xl p-8 h-full transition-transform duration-500 hover:-translate-y-2 hover:shadow-[0_8px_32px_rgba(0,0,0,0.4),0_0_24px_rgba(0,210,255,0.12)]"
                                    data-testid={`service-card-${i}`}
                                >
                                    <div className="mb-6 inline-flex rounded-xl border border-cyan-400/20 bg-gradient-to-br from-cyan-400/15 to-[#3A7BD5]/10 p-3.5 transition-transform duration-500 group-hover:scale-110">
                                        <Icon className="h-7 w-7 text-cyan-400" strokeWidth={1.5} />
                                    </div>
                                    <h3 className="font-display text-2xl font-bold text-white mb-3">
                                        {service.title}
                                    </h3>
                                    <p className="text-sm text-zinc-400 leading-relaxed font-light mb-6">
                                        {service.description}
                                    </p>
                                    <ul className="space-y-2.5">
                                        {service.items.map((item) => (
                                            <li key={item} className="flex items-center gap-2.5 text-sm text-zinc-300">
                                                <Check className="h-4 w-4 text-cyan-400 shrink-0" strokeWidth={2.5} />
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </article>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
